import { useState } from "react";
import { RotateCcw, Search } from "lucide-react";
import { useAdminContent } from "@/context/AdminContentContext";
import { Field, Panel, TextInput } from "@/components/admin/Field";
import { TEXT_GROUPS } from "@/lib/texts";

export default function EditTextos() {
  const { draft, update } = useAdminContent();
  const texts = draft.texts || {};
  const [q, setQ] = useState("");
  const set = (k, v) => update("texts", (t) => { const n = { ...(t || {}) }; if (v === "") delete n[k]; else n[k] = v; return n; });
  const match = (label, def) => !q || `${label} ${def}`.toLowerCase().includes(q.toLowerCase());

  return (
    <>
      <Panel title="Todos os textos do site" description="Cada frase fixa do site pode ser alterada aqui. Deixa um campo vazio para voltar ao texto original. As sincronizações automáticas (Discord, Tebex, regras) continuam a funcionar.">
        <div className="relative">
          <Search size={14} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-eden-muted" aria-hidden="true" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Procurar texto…" className="input-eden pl-9" aria-label="Procurar texto" data-testid="texts-search" />
        </div>
      </Panel>
      {TEXT_GROUPS.map((g) => {
        const items = g.items.filter(([, label, def]) => match(label, def));
        if (!items.length) return null;
        return (
          <Panel key={g.id} title={g.label}>
            <div className="grid gap-4 md:grid-cols-2" data-testid={`texts-group-${g.id}`}>
              {items.map(([key, label, def]) => (
                <Field key={key} label={label} id={`text-${key}`}>
                  <div className="flex gap-2">
                    <TextInput id={`text-${key}`} value={texts[key] ?? ""} onChange={(v) => set(key, v)} placeholder={def} maxLength={400} />
                    {texts[key] && <button type="button" className="btn-ghost h-10 px-2" onClick={() => set(key, "")} aria-label="Repor texto original" title="Repor original" data-testid={`text-reset-${key}`}><RotateCcw size={14} /></button>}
                  </div>
                </Field>
              ))}
            </div>
          </Panel>
        );
      })}
    </>
  );
}
